import { obterGruposProdutoAsync, obterSubGruposProdutoAsync } from "../../services/grupoProdutoService";

const atualizarGruposProduto = async ({ commit }) => {
    const gruposProduto = await obterGruposProdutoAsync();
    commit('atualizarGruposProduto', gruposProduto);
}

const atualizarSubGruposProduto = async ({ commit }) => {
    const subGruposProduto = await obterSubGruposProdutoAsync();
    commit('atualizarSubGruposProduto', subGruposProduto);
}

const atualizarGrupoProduto = ({ commit }, grupoProduto) => {
    commit('atualizarGrupoProduto', grupoProduto);
}

const atualizarSubGrupoProduto = ({ commit }, subGrupoProduto) => {
    commit('atualizarSubGrupoProduto', subGrupoProduto);
}

const addGrupoProduto = ({ commit }, grupoProduto) => {
    commit('addGrupoProduto', grupoProduto);
}

const updateGrupoProduto = ({ commit }, grupoProduto) => {
    commit('updateGrupoProduto', grupoProduto);
}

const addSubGrupoProduto = ({ commit }, subGrupoProduto) => {
    commit('addSubGrupoProduto', subGrupoProduto);
}

const updateSubGrupoProduto = ({ commit }, subGrupoProduto) => {
    commit('updateSubGrupoProduto', subGrupoProduto);
}

export default {
    atualizarGruposProduto,
    atualizarGrupoProduto,
    atualizarSubGruposProduto,
    atualizarSubGrupoProduto,
    addGrupoProduto,
    updateGrupoProduto,
    addSubGrupoProduto,
    updateSubGrupoProduto
}
